import PropTypes from 'prop-types';
import * as React from 'react';
import history from './history';

interface Props {
    errorComponent: React.ComponentType<{ error: unknown }>;
}

export default class ErrorBoundary extends React.Component<React.PropsWithChildren<Props>, { error: unknown }> {
    static propTypes = {
        errorComponent: PropTypes.func,
    };

    state = {
        error: null,
    };

    onUnmount?: () => void;

    componentDidCatch(error: any) {
        this.setState({ error });
    }

    componentDidMount() {
        this.onUnmount = history?.listen(() => {
            if (this.state.error) {
                this.setState({ error: null });
            }
        });
    }

    componentWillUnmount() {
        this.onUnmount?.();
    }

    render() {
        const { errorComponent: ErrorComponent } = this.props;

        if (this.state.error) {
            return <ErrorComponent error={this.state.error} />;
        }

        return this.props.children;
    }
}
